import { escapeForCSV } from '../../../../core/utils/download.js';
import { getUnitAsString } from '../../../core/utils/get-unit-as-string.js';
import type { HistogramBin, HistogramSeries } from '../types/histogram.js';

type BinColumns = keyof HistogramBin;

export function formatCSV(rawData: HistogramSeries[]) {
  const columns = ['name', 'unit', 'from', 'to', 'value'];

  const binsColumns = columns.slice(columns.indexOf('from')) as BinColumns[];

  let csv = `${columns.join(',')}\n`;

  for (const series of rawData) {
    const sanitizedSeriesName = escapeForCSV(series.name);
    const seriesRow = [sanitizedSeriesName, getUnitAsString(series.unit)];

    for (const bins of series.bins) {
      const binsRow: string[] = [];

      for (const column of binsColumns) {
        const value = bins[column];

        const parsedValue = value?.toString() ?? '';
        binsRow.push(parsedValue);
      }

      csv += `${seriesRow.concat(binsRow).join(',')}\n`;
    }
  }

  return csv;
}
